<template>
    <div class="allert-icon" :class="{ 'show': display == true}">
        <div v-if="type == 'success'" class="allert-icon__icon allert-icon__icon--success" @mouseover="getTextWidth()">&#10003;</div>
        <div v-if="type == 'error'" class="allert-icon__icon allert-icon__icon--error" @mouseover="getTextWidth()">!</div>
        <div class="v-label">{{message}}</div>
    </div>
</template>

<script>
export default {

    name: 'labelInfo',
    props:{

        type:{
        type: String,
        default: "success",
        },

        message:{
        type: String,
        default: "",
        },

        display:{
        type: Boolean,
        default: false,
        },

    },
    watch:{

        type(){
            this.getTextWidth();
        }

    },
    methods:{

        getTextWidth() {

                let fontSize = 10;
                let label = this.$el.querySelector('.v-label');

                label.style.fontSize = fontSize;
                label.style.width = 'auto';
                label.style.whiteSpace = 'nowrap';

                label.style.width = label.clientWidth + "px"
                label.style.whiteSpace = 'normal';
        }

    },
    mounted(){

        this.getTextWidth();

    },
}
</script>

<style lang="scss">

.allert-icon{
    display:none;
    float:right;
    margin-top:-25px;
    position: relative;

    &__icon{
        display:flex;
        justify-content: center;
        align-items: center;
        color:#fff;
        font-weight: 400;
        font-size: 12px;
        width: 14px;
        height:14px;
        border-radius:20px;

        &--success{
            background:#30DA51;
        }

        &--error{
            background:#e3000b;
        }

        &:hover ~ .v-label{
            visibility: visible;
        }
    }
}

.v-label{
      position: absolute;
    bottom: 25px;
    right: 0%;
    padding: 7px;
    background-color: red;
    color: #fff;
    text-align: left;
    font-size: 10px;
    font-weight: 400;
    line-height: 1.2;
    //display:inline-block;
    height: auto;
    width: auto;
    white-space: nowrap;
    max-width: 270px;
    visibility: hidden;
}

.form-group.input-error  .allert-icon{
    display:flex;
}

.allert-icon.show{
    display:flex;

    & .v-label{
        visibility: hidden;
    }
}

</style>
